<template>
  <a-modal
    class="iframe-container"
    :visible="visible"
    @ok="handleOk"
    :title="title"
    :width="1300"
    :bodyStyle="{ height: '800px', padding: '0' }"
    :centered="true"
    :footer="null"
    @cancel="handleCancel"
  >
    <iframe
      ref="iframeRef"
      :src="iframeSrc"
      :title="title"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      frameborder="0"
      @load="handleLoad"
      @error="handleError"
    ></iframe>

    <div v-if="loading" class="loading-overlay">
      <div class="default-loading">
        <a-spin />
        <span>正在加载...</span>
      </div>
    </div>

    <div v-if="error" class="error-overlay">
      <ErrorDisplay @retry="initIframe" :errorMessage="errorMessage" />
    </div>
  </a-modal>
</template>

<script setup>
import { onMounted, ref, watch, defineProps, defineExpose } from 'vue'
import { getAdminUser } from '@/api/login'
import ErrorDisplay from './ErrorDisplay.vue'

const props = defineProps({
  followupInfo: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: ''
  },
  followUpType: {
    type: String,
    default: ''
  }
})
const iframeSrc = ref('')
const visible = ref(false)
const src = ref('')
const iframeRef = ref(null)
const errorMessage = '加载失败，请刷新重试'
const loading = ref(false)
const error = ref(false)
const accountInfo = ref(null)

watch(
  () => [props.followupInfo, props.followUpType],
  () => {
    if (visible.value) {
      initIframe()
    }
  },
  { deep: true, immediate: true }
)

// 初始化 iframe（获取 token 并设置 src）
const initIframe = async () => {
  src.value =
    props.followUpType === 'path'
      ? process.env.VUE_APP_FOLLOW_UP_PLAN
      : process.env.VUE_APP_FOLLOW_UP_PATIENT
  loading.value = true
  error.value = false
  iframeSrc.value = ''
  accountInfo.value = null
  try {
    accountInfo.value = await getAccount()
    handleLoad()
  } catch (err) {
    console.log('获取账号密码失败')
    error.value = true
  }
}

const handleLoad = () => {
  // iframe 加载完成后发送 token
  if (iframeRef.value && accountInfo.value) {
    const { orgId, followupPlanId, id, ucPatientId } = props.followupInfo
    const srcValue = props.followUpType === 'path' ? src.value : `${src.value}/${ucPatientId}`
    const commonParams = `menuHide=true&orgId=${orgId}&account=${accountInfo.value?.userName}&password=${accountInfo.value?.password}`
    const diffParams =
      props.followUpType === 'path'
        ? `followupPlanId=${followupPlanId}`
        : `patientId=${ucPatientId}&patientPlanId=${id}&origin=${props.origin}`
    iframeSrc.value = `${srcValue}?${commonParams}&${diffParams}`
  }
  console.log('跳转随访链接------------', iframeSrc.value)
  loading.value = false
}

const handleError = () => {
  loading.value = false
  error.value = true
}

const getAccount = async () => {
  try {
    if (!props.followupInfo.orgId) return
    const res = await getAdminUser({ orgId: props.followupInfo.orgId })
    return res || {}
  } catch (err) {
    error.value = true
  }
}
const handleCancel = () => {
  visible.value = false
}
const handleOk = () => {}
onMounted(() => {
  initIframe()
})
defineExpose({
  visible
})
</script>

<style scoped lang="scss">
.iframe-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-right: 1px solid #f0f0f0;

  iframe {
    margin: 0;
    padding: 0;
    border: none;
    width: 100%;
    height: 100%;
  }

  .loading-overlay,
  .error-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f6fa;
    z-index: 10;
  }
}
</style>
